import React from "react";
import Sidebar from "../Sidebar";

const Loader = () => {
  return (
    <>
      <Sidebar />
      <div className="loader_container">
        <span class="loader"></span>
      </div>
    </>
  );
};

export default Loader;
